import { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

/**
 * `ORG_CONNECTED_APPS_RATE_TRAIT` is keyed by smartlink provider family, which is coarser
 * than the `ProductKeys3P` the icons need — `google` covers Drive, Gmail and Calendar, so
 * Drive stands in for the family. Keys that already agree pass through.
 */
const PROVIDER_FAMILY_TO_PRODUCT_KEY: Record<string, ProductKeys3P> = {
	google: ProductKeys3P.GoogleDrive,
};

/** TAP trait keys (e.g. `google`) match `meta.key` minus the `-object-provider` suffix. */
export const toTraitKey = (key: string | undefined): string | undefined =>
	key?.replace(/-object-provider$/, '');

export const toProductKeyRates = (
	rates: Record<string, number> | undefined,
): Record<string, number> | undefined => {
	if (!rates) {
		return undefined;
	}
	const mapped: Record<string, number> = {};
	for (const [family, percent] of Object.entries(rates)) {
		mapped[PROVIDER_FAMILY_TO_PRODUCT_KEY[family] ?? family] = percent;
	}
	return mapped;
};
